import React from 'react';
import { Avatar } from '@shoflo/polymer/components/Avatar/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DropdownMultiSelect from 'components/DropdownMultiSelect';
import { AVAILABLE_TOOLS } from 'constants/AvailableTools';
import CrewRolePicker from 'components/event/CrewRolePicker';

const StyledTD = styled.td`
  border-top: none !important;
  border-bottom: 2px solid #f0f2f6;
  vertical-align: middle !important;
  padding: 0.5rem 0 !important;
  font-size: 14px;
`;

const UserWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledUserName = styled.div`
  font-weight: 600;
  line-height: 24px;
  color: #333333;
  margin-left: 10px;

  @media only screen and (max-width: 768px) {
    margin-left: 10px;
  }
`;

const StyledEm = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #767676;
`;

const StyledSubText = styled(StyledEm)`
  margin-left: 10px;

  @media only screen and (max-width: 768px) {
    display: none;
    margin-left: 10px;
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  margin-left: 14px;
`;

const CrewListItem = ({ selectedOptions, onChangeRoleClick }) => {
  const getDropdownOptions = (email) =>
    Object.entries(AVAILABLE_TOOLS).map((tool) => {
      const toggledTools = [];

      selectedOptions.forEach((option) => {
        option.email === email &&
          option.availableTools &&
          toggledTools.push(...option.availableTools);
      });

      return {
        ...(toggledTools.length && {
          checked:
            tool.includes(toggledTools[0]) || tool.includes(toggledTools[1]),
        }),
        id: `${tool[1]}-${email}`,
        name: tool[1],
        label: tool[1],
        value: tool[0],
      };
    });

  const handleDropdownItemSelect = (email, event) => {
    const toggledTool = event.target.value;
    const modifiedSelectedTools = selectedOptions.map((option) => {
      if (option.email === email) {
        if (!option.availableTools) {
          option.availableTools = [];
        }

        if (option.availableTools.includes(toggledTool)) {
          const index = option.availableTools.indexOf(toggledTool);
          index > -1 && option.availableTools.splice(index, 1);
        } else {
          option.availableTools.push(toggledTool);
        }
      }
      return option;
    });
    onChangeRoleClick(modifiedSelectedTools);
  };

  const handlePermissionSelect = (role, email) => {
    const modifiedSelectedOptions = selectedOptions.map((option) => {
      if (option.email === email) {
        option.role = role;
      }
      return option;
    });
    onChangeRoleClick(modifiedSelectedOptions);
  };

  const getButtonText = (availableTools) =>
    availableTools && availableTools.length
      ? availableTools.length > 1
        ? 'Rundown +1'
        : AVAILABLE_TOOLS[availableTools[0]]
      : null;

  const removeFromSelectedOptions = (email) => {
    const modifiedSelectedOptions = selectedOptions.filter(
      (option) => option.email !== email,
    );

    onChangeRoleClick(modifiedSelectedOptions);
  };

  return (
    <tbody>
      {selectedOptions.map((option) => {
        const { email } = option;
        const user = option.user || {
          firstName: 'New',
          lastName: 'User',
          email,
        };

        return (
          <tr
            key={user.email}
            data-testid={'crewRow-' + user.firstName + user.lastName}
          >
            <StyledTD>
              <UserWrapper>
                <Avatar user={user} />
                <div>
                  <StyledUserName
                    data-testid={'crewName-' + user.firstName + user.lastName}
                  >
                    {user.firstName} {user.lastName}
                  </StyledUserName>
                  <StyledSubText>{user.email}</StyledSubText>
                </div>
              </UserWrapper>
            </StyledTD>

            <StyledTD>
              <DropdownMultiSelect
                type="checkbox"
                srMessage="Dropdown-Select-Button"
                onClick={(event) => handleDropdownItemSelect(user.email, event)}
                options={getDropdownOptions(user.email)}
                id={`product-select-${user.email}`}
                buttonText={getButtonText(option.availableTools)}
              />
            </StyledTD>

            <StyledTD>
              <CrewRolePicker
                userId={user.email}
                onChange={(role) => handlePermissionSelect(role, user.email)}
              />

              <StyledIcon
                data-testid={`styledTrashIcon-${user.email}`}
                icon={faTrash}
                onClick={() => removeFromSelectedOptions(user.email)}
              />
            </StyledTD>
          </tr>
        );
      })}
    </tbody>
  );
};

CrewListItem.propTypes = {
  selectedOptions: PropTypes.array.isRequired,
  onChangeRoleClick: PropTypes.func.isRequired,
};

export default CrewListItem;
